import React, {Component} from 'react';
import './App.css';
import championRabbit from './assets/championRabbit_800.png';
import thumbnailChampionRabbit from './assets/championRabbit_300-200.png';
import smallRabbits from './assets/smallRabbits_800.png';
import smallRabbit from './assets/smallRabbit_800.png';
import thumbnailSmallRabbit from './assets/smallRabbit_300-200.png';
import {Row, Col, Container, Image, Carousel, Navbar, NavDropdown, Nav} from "react-bootstrap";

class App extends Component {
    render() {
        return (
            <React.Fragment>
                <Navbar bg="dark" expand="lg" className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
                    <Navbar.Brand href="#home">RozkvetlyStatek.cz</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <Nav.Link href="#home">Domů</Nav.Link>
                            <Nav.Link href="#about">O nás</Nav.Link>
                            <Nav.Link href="#contact">Kontakt</Nav.Link>
                            {/*                <NavDropdown title="Další informace" id="basic-nav-dropdown">
                                              <NavDropdown.Item href="#action/3.1">GDPR</NavDropdown.Item>
                                              <NavDropdown.Item href="#action/3.2">...</NavDropdown.Item>
                                              <NavDropdown.Item href="#action/3.3">...</NavDropdown.Item>
                                              <NavDropdown.Divider />
                                              <NavDropdown.Item href="#action/3.4">O aplikaci</NavDropdown.Item>
                                            </NavDropdown>*/}
                        </Nav>

                    </Navbar.Collapse>
                </Navbar>

                <main role="main" id="home">
                    <Carousel>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src={championRabbit}
                                alt="Naše ocenění"
                            />
                            <Carousel.Caption>
                                <h3>Rozkvetlý statek</h3>
                                <p>Naše ocenění</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src={smallRabbits}
                                alt="Malý králíčci"
                            />

                            <Carousel.Caption>
                                <h3>RozkvetlyStatek.cz</h3>
                                <p>Malý rošťáci.</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src={smallRabbit}
                                alt="Králíček do ruky"
                            />

                            <Carousel.Caption>
                                <h3>RozkvetlyStatek.cz - rok 2019</h3>
                                <p>Králíček nezabere moc místa.</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>

                    <hr/>

                    <Row>
                        <Col md={7}>
                            <h2 id="about">O nás</h2>
                            <p className="lead text-justify">Rozkvetly statek je chovná stanice králíčků vhodných pro
                                soutěže.</p>
                        </Col>
                        <Col md={5}>
                            <Image alt="" src={thumbnailChampionRabbit} thumbnail/>
                        </Col>
                    </Row>

                    <hr/>

                    <Row>
                        <Col md={5}>
                            <Image alt="" src={thumbnailSmallRabbit} thumbnail/>
                        </Col>
                        <Col md={7}>
                            <h2 id="contact">Kontakt</h2>
                            <p className="lead text-justify">Email: <a
                                href="mailto:Mazlici@RozkvetlyStatek.cz">Mazlici@RozkvetlyStatek.cz</a></p>
                        </Col>
                    </Row>

                    <hr/>

                </main>

                <footer className="container">
                    <p>&copy; RozkvetlyStatek.CZ 2019</p>
                </footer>
            </React.Fragment>

        );
    }
}

export default App;
